import React from "react";

export const CubeContext = React.createContext();